'use client';

import { LoginData, LoginPayload } from './auth.type';
import { apiClient } from '@/slw/shared/global/client';

import { saveTokenServer } from '@/slw/shared/lib/auth.server';

export const loginServerAction = async (data: LoginPayload) => {
  // Tạo payload cho API call
  const apiPayload = {
    username: data.username,
    password: data.password,
    fcmToken: data.fcmToken || '',
    isRemembered: data.isRemembered || false,
  };

  const response = await apiClient().post<LoginData>('/ecom-users/authenticate', apiPayload);

  if (response.success) {
    await saveTokenServer(response.data.token);
  }

  return response;
};
